import { AutocompleteElement } from "@nosto/search-js/preact/autocomplete";
import { SearchKeyword } from "@nosto/nosto-js/client";
import { useOnSubmit } from "../OnSubmitContext";

type KeywordProps = {
  keyword: SearchKeyword;
};

export default function Keyword({ keyword }: KeywordProps) {
  const onSubmit = useOnSubmit();

  return (
    <AutocompleteElement
      hit={keyword}
      componentProps={{
        onClick: (e: Event) => {
          e.preventDefault();
          if (keyword._redirect) {
            window.location.href = keyword._redirect;
          } else {
            onSubmit(keyword.keyword, { isKeyword: true });
          }
        },
      }}
    >
      {keyword.keyword && (
        <span dangerouslySetInnerHTML={{ __html: keyword.keyword }} />
      )}
    </AutocompleteElement>
  );
}
